// src/shared/components/Button.js
import React from 'react';
import { Loader } from 'lucide-react';

const Button = ({ 
  children, 
  type = 'button', 
  variant = 'primary', 
  isLoading = false, 
  className = '',
  ...props 
}) => {
  const baseClasses = 'px-4 py-2 rounded-md font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-500',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    success: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500',
  };
  
  return (
    <button
      type={type}
      className={`${baseClasses} ${variants[variant]} ${className} ${isLoading ? 'opacity-75 cursor-not-allowed' : ''}`}
      disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center justify-center">
          <Loader className="animate-spin h-5 w-5 mr-2" />
          Loading...
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;